<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        流程编排
        <small>流程编排</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 流程编排
          </a>
        </li>
        <li class="active">流程编排</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar">
          <button class="btn btn-warning" type="button" id="sys_arrange" @click="arrange">
            <i class="fa fa-pencil"></i>&nbsp;编排
          </button>
        </div>
        <table id="workflow_list_table"></table>
      </div>
    </section>

    <!-- 编排框 modal -->
    <v-workflowarrange ref="workflowArrange"></v-workflowarrange>
  </div>
</template>

<script>
  import workflowArrange from './workflowArrange'

  export default {
    name: 'workflowList',
    data() {
      return {}
    },
    components: {
      'v-workflowarrange': workflowArrange
    },
    mounted: function () {
      // 获取所有的流程编排
      var self = this
      console.log('___请求数据')
      $('#workflow_list_table').bootstrapTable({
        url: self.global.apiHost + 'workflow_list/',
        method: 'get', // 请求方式（*）
        ajaxOptions: {
          headers: {
            'content-type': 'application/json', // 默认值
            Authorization: 'Bearer ' + localStorage.getItem('access_token')
          }
        },
        toolbar: '#atptoolbar', // 工具按钮用哪个容器
        height: $(window).height() * 0.86,
        striped: true, // 是否显示行间隔色
        cache: false, // 是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
        pagination: true, // 是否显示分页（*）
        iconSize: 'outline',
        sortable: true, // 是否启用排序
        sortName: 'id',
        sortOrder: 'DESC', // 排序方式
        queryParams: self.queryParams, // 传递参数（*）
        sidePagination: 'server', // 分页方式：client客户端分页，server服务端分页（*）
        pageNumber: 1, // 初始化加载第一页，默认第一页
        pageSize: 10, // 每页的记录行数（*）
        pageList: [10], // 可供选择的每页的行数（*）
        // search: true, // 是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
        showColumns: true, // 是否显示所有的列
        showRefresh: true, // 是否显示刷新按钮
        minimumCountColumns: 2, // 最少允许的列数
        clickToSelect: true, // 是否启用点击选中行
        singleSelect: true, // 是否启用单选
        uniqueId: 'id', // 每一行的唯一标识，一般为主键列
        responseHandler: function (res) {
          console.log('___获取待编排到数据', res)
          return {
            total: res.total, // 总页数
            rows: res.rows // 数据
          }
        },
        columns: [
          [
            {checkbox: true},
            {
              title: '工作流ID',
              width: 40,
              field: 'id'
            },
            {
              title: '流程名称',
              width: 40,
              field: 'name'
            }
          ]
        ]
      })
    },
    methods: {
      queryParams: function (param) {
        param.org_id = JSON.parse(localStorage.getItem('companyInfo')).id
        param.per_page = param.limit
        param.page = param.offset / param.limit + 1
        return param
      },
      // 编排
      arrange: function () {
        var self = this
        var selectedRows = $('#workflow_list_table').bootstrapTable('getSelections')
        console.log('___已workflowArrange选中的行', selectedRows)
        if (selectedRows.length !== 1) {
          alert('必须只选择一项')
          return
        }

        setTimeout(function () {
          self.$refs.workflowArrange.initFunc(selectedRows[0]) // 调用子组件函数
        }, 1000)

      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/workflowList.vue